var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M108.467708,1.99766355 C106.238919,-0.66588785 102.710004,-0.66588785 100.666948,1.99766355 L36.2178134,79.0186916 L9.4723512,47.0560748 C7.24356268,44.3925234 3.71464753,44.3925234 1.67159139,47.0560748 C-0.55719713,49.7196262 -0.55719713,53.9369159 1.67159139,56.3785047 L32.3174335,93.0023364 C33.4318278,94.3341121 34.9176868,95 36.2178134,95 C37.5179401,95 39.0037991,94.3341121 40.1181933,93.0023364 L108.467708,11.3200935 C110.510764,8.87850467 110.510764,4.66121495 108.467708,1.99766355 L108.467708,1.99766355 Z","fillRule":"nonzero"}));
}

Checkmark.defaultProps = {"viewBox":"0 0 110 95","version":"1.1"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
